import { Text, TextSize, Weight } from 'components'
import styled from 'styled-components'
import { GLOBAL_COLORS } from 'theme'

export const Wrapper = styled.div``

export const ItemContainer = styled.div`
  border-bottom: 1px solid ${GLOBAL_COLORS.secondGrey02};
  padding-top: 15px;
  &:last-of-type {
    border-bottom: none;
  }
`

export const IconContainer = styled.div`
  height: 40px;
  width: 40px;
  & > img {
    height: 40px;
    width: 40px;
  }
`

export const SymbolContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 30px;
  margin-top: 15px;
  padding-bottom: 15px;
`

export const InfoItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: fill-available;
  text-align: center;
`

export const SymbolText = styled(Text)`
  font-size: ${TextSize.p};
  font-weight: ${Weight.SemiBold};
`

export const ValueText = styled(Text)`
  font-size: ${TextSize.nav};
  font-weight: ${Weight.SemiBold};
`

export const SubtitleText = styled(Text)`
  font-size: ${TextSize.four};
  font-weight: ${Weight.Medium};
  opacity: 0.7;
`

export const TopRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 15px;
`
export type AllocationPieProps = {
  data: string
  isDarkMode: boolean
}

export const StyledAllocationContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  align-items: center;
  gap: 10px;
`
